// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page":"page___2FqAF","container":"container___5QwdC","searchContainer":"searchContainer___3hIof","description":"description___1YvQc"};